export default __webpack_public_path__ + "static/media/pdf.d2d0dafb.png";